import { IMapPinBase, IMapPinResponseBase } from '@/bundles/Map/types';
import { Nullable } from '@/utils/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

export class MapPinBase implements IMapPinBase {
  readonly id: string;
  readonly lat: Nullable<number>;
  readonly lng: Nullable<number>;
  readonly number: number;

  constructor (data: IMapPinResponseBase, number: number) {
    this.id = data._key;
    this.lat = isValuePresent(data.lat) ? parseFloat(data.lat) : null;
    this.lng = isValuePresent(data.long) ? parseFloat(data.long) : null;
    this.number = number;
  }
}
